import React from "react";
import Login from "../Components/user/Login";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
